// extracted by mini-css-extract-plugin
export var acitonButtons = "_i4-0";
export var additionalIcon = "_i4-f";
export var block = "_i4-1";
export var blockContent = "_i4-7";
export var blockDescription = "_i4-8";
export var blockIcon = "_i4-9";
export var blockTitle = "_i4-6";
export var border = "_i4-a";
export var center = "_i4-l";
export var edge = "_i4-b";
export var edgeLabel = "_i4-c";
export var edgePath = "_i4-d";
export var error = "_i4-e";
export var flowchart = "_i4-g";
export var flowchartContent = "_i4-h";
export var highlighted = "_i4-3";
export var hover = "_i4-4";
export var icon = "_i4-i";
export var left = "_i4-m";
export var navButton = "_i4-j";
export var navButtons = "_i4-k";
export var right = "_i4-n";
export var selected = "_i4-2";
export var small = "_i4-5";